import React from 'react';
import { Image } from 'react-native';

import {
	DuelChipsJpg,
	DuelScoreCardsSvg,
	DuelScoreFlameSvg,
	DuelScoreStarSvg,
} from '../../../assets/duels';

export const DUEL_SCORE_SOURCES = [
	{
		key: 'outcome',
		title: 'T_SITE_DUELS_SOURCE_OUTCOME',
		body: 'T_SITE_DUELS_SOURCE_OUTCOME_BODY',
	},
	{
		key: 'decisionQuality',
		title: 'T_SITE_DUELS_SOURCE_DECISIONS',
		body: 'T_SITE_DUELS_SOURCE_DECISIONS_BODY',
	},
	{
		key: 'riskManagement',
		title: 'T_SITE_DUELS_SOURCE_RISK',
		body: 'T_SITE_DUELS_SOURCE_RISK_BODY',
	},
	{ key: 'timeBonus', title: 'T_SITE_DUELS_SOURCE_TIME', body: 'T_SITE_DUELS_SOURCE_TIME_BODY' },
] as const;

export type DuelScoreSourceKey = (typeof DUEL_SCORE_SOURCES)[number]['key'];

export const DuelScoreSourceIcon = ({
	source,
	size,
}: {
	source: DuelScoreSourceKey;
	size: number;
}) => {
	switch (source) {
		case 'outcome':
			return (
				<Image source={DuelChipsJpg} style={{ width: size, height: size }} resizeMode='contain' />
			);
		case 'decisionQuality':
			return <DuelScoreStarSvg width={size} height={size} />;
		case 'riskManagement':
			return <DuelScoreCardsSvg width={size} height={size} />;
		default:
			return <DuelScoreFlameSvg width={size} height={size} />;
	}
};
